import React from 'react';
import { useCardHeight } from '../context/CardHeightContext';
import { useCardMeasure } from '../hooks/useCardMeasure';

interface CardContentProps {
  children: React.ReactNode;
}

export function CardContent({ children }: CardContentProps) {
  const measureRef = useCardMeasure();
  const { maxHeight } = useCardHeight();

  return (
    <div 
      ref={measureRef}
      className="flex flex-col h-full p-5"
      style={{ minHeight: maxHeight > 0 ? `${maxHeight}px` : undefined }}
    >
      {children}
    </div>
  );
}